export const RATING_SCALE_TYPES = {
  LIKERT_AGREEMENT_5: "likert_agreement_5",
  NUMERIC_5: "numeric_5",
  NUMERIC_10: "numeric_10",
  STARS_5: "stars_5",
  SATISFACTION_5: "satisfaction_5",
  FREQUENCY_5: "frequency_5",
  DESCRIPTIVE_4: "descriptive_4",
};

const SCALE_LABELS = {
  [RATING_SCALE_TYPES.LIKERT_AGREEMENT_5]: [
    "Strongly Agree",
    "Agree",
    "Neutral",
    "Disagree",
    "Strongly Disagree",
  ],
  [RATING_SCALE_TYPES.SATISFACTION_5]: [
    "Very Satisfied",
    "Satisfied",
    "Neutral",
    "Dissatisfied",
    "Very Dissatisfied",
  ],
  [RATING_SCALE_TYPES.FREQUENCY_5]: [
    "Always",
    "Often",
    "Sometimes",
    "Rarely",
    "Never",
  ],
  [RATING_SCALE_TYPES.DESCRIPTIVE_4]: [
    "Excellent",
    "Good",
    "Fair",
    "Poor",
  ],
};

export function getRatingScaleConfig(question) {
  // New format: rating config stored as object in question.options
  if (question?.questionType === "rating" || question?.type === "rating") {
    if (question?.options && typeof question.options === "object" && !Array.isArray(question.options)) {
      return {
        scaleType: question.options.scaleType || RATING_SCALE_TYPES.NUMERIC_5,
        numericMax: question.options.numericMax,
      };
    }
  }

  // Legacy format: fixed 1-5 numeric
  return { scaleType: RATING_SCALE_TYPES.NUMERIC_5, numericMax: 5 };
}

export function getRatingOptions(question) {
  const { scaleType, numericMax } = getRatingScaleConfig(question);

  if (scaleType === RATING_SCALE_TYPES.NUMERIC_10) {
    return Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
  }

  if (scaleType === RATING_SCALE_TYPES.NUMERIC_5) {
    const max = typeof numericMax === "number" && numericMax > 0 ? numericMax : 5;
    return Array.from({ length: max }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
  }

  if (scaleType === RATING_SCALE_TYPES.STARS_5) {
    return Array.from({ length: 5 }, (_, i) => ({
      value: i + 1,
      label: "★".repeat(i + 1),
    }));
  }

  const labels = SCALE_LABELS[scaleType];
  if (labels && Array.isArray(labels)) {
    return labels.map((label) => ({ value: label, label }));
  }

  // Fallback to legacy numeric 1-5
  return Array.from({ length: 5 }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
}

export function getRatingScaleTypeLabel(scaleType) {
  switch (scaleType) {
    case RATING_SCALE_TYPES.LIKERT_AGREEMENT_5:
      return "Likert (Agreement)";
    case RATING_SCALE_TYPES.NUMERIC_5:
      return "Numeric (1–5)";
    case RATING_SCALE_TYPES.NUMERIC_10:
      return "Numeric (1–10)";
    case RATING_SCALE_TYPES.STARS_5:
      return "Star Rating (1–5)";
    case RATING_SCALE_TYPES.SATISFACTION_5:
      return "Satisfaction";
    case RATING_SCALE_TYPES.FREQUENCY_5:
      return "Frequency";
    case RATING_SCALE_TYPES.DESCRIPTIVE_4:
      return "Descriptive";
    default:
      return "Rating";
  }
}

